import { SaveAlt, Search } from "@material-ui/icons";
import { Fab, Grid, TextField, Tooltip } from "@mui/material";
import Select from "components/select/Select";
import { ALL_OPTION } from "constant";
import { LIST_USER_ROLE, TELEPHONIST_ROLE } from "constant/user";
import { useFormik } from "formik";
import { useCityDistrictProvince } from "hooks/select/useCityDistrictProvince";
import { useMemo } from "react";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

import { convertRoleCodeToListLevel } from "../utils/user.util";

const UserFilter = ({ defaultValues, onSubmit, onClickDownload }) => {
  const formik = useFormik({
    initialValues: defaultValues,
    onSubmit,
  });

  const formValues = formik.values;

  const {
    listCityPostOfficeOptions,
    listDistrictPostOfficeOptions,
    listProvinceOptions,
  } = useCityDistrictProvince({
    citycode: formValues?.city,
    districtcode: formValues?.district,
  });

  // lọc danh sách cấp quản lý theo giá trị phân quyền
  const listLevel = useMemo(
    () => convertRoleCodeToListLevel(formValues.role),
    [formValues.role]
  );

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "username")}
            label="Tài khoản"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "fullname")}
            label="Họ tên"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "phoneNumber")}
            label="Số điện thoại"
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "status")}
            showSearch={false}
            showAllOption
            options={[
              {
                label: "Đang hoạt động",
                value: true,
              },
              {
                label: "Ngừng hoạt động",
                value: false,
              },
            ]}
            label="Trạng thái hoạt động"
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            label="Phân quyền"
            options={LIST_USER_ROLE.map((role) => {
              return { label: role.roleDisplayName, value: role.roleName };
            })}
            showSearch={false}
            showAllOption
            {...getSelectFieldProps(formik, "role")}
            onChange={async (newValue) => {
              await formik.setFieldValue("role", newValue);
              await formik.setFieldValue(
                "level",
                newValue === TELEPHONIST_ROLE ? "postoffice" : ALL_OPTION.value
              );
              await formik.setFieldValue("city", ALL_OPTION.value);
              await formik.setFieldValue("district", ALL_OPTION.value);
              await formik.setFieldValue("postoffice", ALL_OPTION.value);
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            label="Cấp quản lý"
            showSearch={false}
            showAllOption={formValues.role !== TELEPHONIST_ROLE}
            options={listLevel}
            {...getSelectFieldProps(formik, "level")}
            onChange={async (newValue) => {
              await formik.setFieldValue("level", newValue);
              await formik.setFieldValue("city", ALL_OPTION.value);
              await formik.setFieldValue("district", ALL_OPTION.value);
              await formik.setFieldValue("postoffice", ALL_OPTION.value);
            }}
          />
        </Grid>

        {(formValues?.level === "city" ||
          formValues?.level === "district" ||
          formValues?.level === "postoffice") && (
          <Grid item xs={3}>
            <Select
              label="Bưu điện tỉnh/thành phố"
              {...getSelectFieldProps(formik, "city")}
              onChange={async (newValue) => {
                await formik.setFieldValue("city", newValue);
                await formik.setFieldValue("district", ALL_OPTION.value);
                await formik.setFieldValue("postoffice", ALL_OPTION.value);
              }}
              options={listCityPostOfficeOptions}
              showAllOption
            />
          </Grid>
        )}

        {(formValues?.level === "district" ||
          formValues?.level === "postoffice") && (
          <Grid item xs={3}>
            <Select
              label="Bưu điện huyện"
              {...getSelectFieldProps(formik, "district")}
              onChange={async (newValue) => {
                await formik.setFieldValue("district", newValue);
                await formik.setFieldValue("postoffice", ALL_OPTION.value);
              }}
              options={listDistrictPostOfficeOptions}
              showAllOption
            />
          </Grid>
        )}

        {formValues?.level === "postoffice" && (
          <Grid item xs={3}>
            <Select
              label="Bưu cục"
              {...getSelectFieldProps(formik, "postoffice")}
              options={listProvinceOptions}
              showAllOption
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <Tooltip title="Tìm kiếm">
            <Fab
              color="primary"
              aria-label="Search"
              type="submit"
              sx={{ mr: 1 }}>
              <Search />
            </Fab>
          </Tooltip>
          <Tooltip title="Tải danh sách tài khoản">
            <Fab
              color="primary"
              aria-label="Search"
              type="submit"
              onClick={onClickDownload}>
              <SaveAlt />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default UserFilter;
